'use client';

import Link from 'next/link';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useAgendamentoNavigation } from '@/hooks/navigation/use-agendamento-navigation.hook';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface LaboratoryErrorFallbackProps {
  message: string;
  laboratoryId: string;
  dataTestId?: string;
  onRetry(): void;
}

export function LaboratoryErrorFallback({
  message,
  laboratoryId,
  dataTestId,
  onRetry,
}: LaboratoryErrorFallbackProps) {
  const { buildLink } = useAgendamentoNavigation();

  return (
    <div role="alert" data-testid={dataTestId} className="flex flex-col items-center gap-3 px-6 py-10">
      <Typography variant={TypographyVariant.BODY_TEXT} className="text-center text-gray-500">
        {message}
      </Typography>

      <Button
        variant="secondary"
        data-testid={DataTestIdEnum.BRANCH_LABORATORY_ERROR_RETRY}
        onClick={onRetry}
      >
        Tentar novamente
      </Button>

      <Link
        prefetch={false}
        href={buildLink({ path: `/laboratorio/${laboratoryId}/` })}
        data-testid={DataTestIdEnum.BRANCH_LABORATORY_ERROR_REDIRECT}
        data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_SELECT_REDIRECT_EXAMS_AND_SCHEDULES}
        className="text-green-500 font-semibold underline"
      >
        Exames e horários
      </Link>
    </div>
  );
}
